export default __webpack_public_path__ + "static/media/Notice of Changes on your Funeral Insurance Policy.94b73b6c.pdf";